;(function($) {
var cpb = $('#product-builder');
var redirectUrl = '/pages/bundle-and-save';
  
  
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);
  
function init() {
  modifyProductInCartInit();
  redirectOnAddToCart()
}

function redirectOnAddToCart() {
  const productsToRedirect = ['4509159096400']
  const productId = $('#product-builder').attr('data-product-id')
  if(productsToRedirect.includes(productId) === false) return
  document.addEventListener('cpb-add-to-cart', () => {
    location.href = '/pages/bundle-and-save'
  })
}

function modifyProductInCartInit() {
if(window.location.search.indexOf('&modifyProduct=') === -1) return;
var keyId = window.location.search.split('&modifyProduct=')[1];
keyId = keyId.split('&')[0];
var addToCartBtn = $('.cpb-add-to-cart-button');
addToCartBtn.find('span').html('Update Cart');
addToCartBtn.on('click', function() {
$.get('/cart/change.js', {
'id': keyId,
'quantity': 0
});
});
}

})(jQuery);
